import { ReactNode } from 'react';

import { ButtonBarHolder, InnerButtonBarHolder } from './ButtonBar.styled';

type Props = {
  children: ReactNode;
};

export function ButtonBar({ children }: Props) {
  return (
    <ButtonBarHolder id="button-bar-container">
      <InnerButtonBarHolder>{children}</InnerButtonBarHolder>
    </ButtonBarHolder>
  );
}
